import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 md:px-12 lg:px-20 pt-20 pb-10 bg-[#050505]"
    >
      <div className="border-b border-[#2A2A2A] pb-16">
        <h3
          className="font-display font-bold uppercase leading-[0.85] tracking-tighter text-[20vw] lg:text-[14rem]"
          aria-hidden
        >
          <span className="text-stroke">Big</span>{" "}
          <span className="text-[#FFD600]">Bubbles</span>
        </h3>
      </div>

      <div className="grid md:grid-cols-12 gap-10 py-12 border-b border-[#2A2A2A]">
        <div className="md:col-span-5">
          <p className="text-sm text-gray-400 max-w-md leading-relaxed">
            Big Bubbles is a fully-mobile pressure washing crew based in Saint John, NB.
            Residential, commercial, and heavy equipment — done right, done local.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#FFD600] mb-4">
            Quick Links
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#services" className="text-gray-300 hover:text-[#FFD600]">
                Services
              </a>
            </li>
            <li>
              <a href="#why" className="text-gray-300 hover:text-[#FFD600]">
                Why Big Bubbles
              </a>
            </li>
            <li>
              <a href="#gallery" className="text-gray-300 hover:text-[#FFD600]">
                Before & After
              </a>
            </li>
            <li>
              <a href="#quote" className="text-gray-300 hover:text-[#FFD600]">
                Free Quote
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#FFD600] mb-4">
            Contact
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="tel:+15066084350" className="text-white hover:text-[#FFD600] font-display text-lg uppercase">
                (506) 608-4350
              </a>
            </li>
            <li>
              <a href="mailto:stevenunderhill40@gmail.com" className="text-gray-300 hover:text-[#FFD600] break-all">
                stevenunderhill40@gmail.com
              </a>
            </li>
            <li className="text-gray-400">Saint John, New Brunswick</li>
          </ul>

          <div className="mt-6 flex gap-3">
            <a
              href="#"
              data-testid="social-instagram"
              aria-label="Instagram"
              className="w-10 h-10 border border-[#2A2A2A] flex items-center justify-center hover:border-[#FFD600] hover:text-[#FFD600] text-gray-400 transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              data-testid="social-facebook"
              aria-label="Facebook"
              className="w-10 h-10 border border-[#2A2A2A] flex items-center justify-center hover:border-[#FFD600] hover:text-[#FFD600] text-gray-400 transition-colors"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-gray-500">
        <span>© {new Date().getFullYear()} Big Bubbles · Fully Insured · Saint John, NB</span>
        <span>Built tough for the East Coast</span>
      </div>
    </footer>
  );
}
